define('views/content/cd_license',['require','backbone','marionette','typeahead','bloodhound','text!templates/content/cd_license.html'],function(require){

    var Backbone = require('backbone');
    require('marionette');
    require('typeahead');
    require('bloodhound');


    var temp = require("text!templates/content/cd_license.html");

    return Backbone.Marionette.LayoutView.extend({
        // html template for the view
        template: _.template(temp),
        className: 'cd-license-page',
        titleKey: 'license',
        selectedDistributor: null,

        initialize: function(options) {
            App.context.changePageTitle(App.polyglot.t(this.titleKey));
        },

        ui: function() {
            return {
                distributorField: '.distributors-typeahead',
                countField: '#count',
                note: "#note",
                assignButton: '#assign-button'
            };
        },

        events: {
            'click @ui.assignButton': 'assignButtonClicked'
        },
        
        onRender: function() {
            var _this = this;

            // Setup typeahed for customer field
            var distributorsTypeahedEngine = new Bloodhound({
                datumTokenizer: Bloodhound.tokenizers.whitespace,
                queryTokenizer: Bloodhound.tokenizers.whitespace,
                remote: {
                    url: App.Config.apiBase + 'distributors/typeahead/',
                    replace: function(url, query) {
                        return url + ('?query=' + encodeURIComponent(_this.ui.distributorField.val()));
                    }
                },
                identify: function(obj) {
                    return obj.id;
                }
            });

            this.ui.distributorField.typeahead({
                minLength: 3
            }, {
                name: 'distributors',
                source: distributorsTypeahedEngine,
                display: 'company_name'
            });

            // Get selected distributor's id
            this.ui.distributorField.bind('typeahead:select', function (ev, suggestion) {
                _this.selectedDistributor = suggestion.id;
            });
        },

        assignButtonClicked: function () {
            var _this = this;

            if (this.selectedDistributor) {
                _this.ui.assignButton.addClass('loading');

                $.ajax({
                    url: App.Config.apiBase + 'cd-products/' + this.model.get('id') + '/assign_license/',
                    method: 'post',
                    data: {
                        distributor: this.selectedDistributor,
                        count: this.ui.countField.val(),
                        note: this.ui.note.val()
                    },
                    success:function(response) {
                        _this.ui.assignButton.removeClass('loading');

                        _this.model.set(response);
                        _this.render();

                        App.utils.showMessage('success', App.polyglot.t('assign_success'));
                    },
                    error: function (xhr, ajaxOptions, thrownError) {
                        _this.ui.assignButton.removeClass('loading');

                        // Show error messages
                        if (xhr.responseJSON.errors) {
                            for (var i=0; i<xhr.responseJSON.errors.length; i++) {
                                App.utils.showMessage('error', xhr.responseJSON.errors[i].message);
                            }
                        }
                    }
                });
            }
        }

    });
});
